import { SelectItem } from '../../types/ui';

export const getItemByKey = <T>(key: T, options: SelectItem<T>[]): SelectItem<T> | undefined =>
  options?.find(option => option.value === key);
